import { Box, Grid } from "@chakra-ui/react";
import { useRef, useState } from "react";
import { SectionHead } from "@/components";
import { KNIT_NEEDLES, KNIT_NEEDLES_HEAD } from "@/content";
import { NeedleBed, type NeedleBedHandle } from "./knit/NeedleBed";
import { StepList } from "./knit/StepList";

export const KnittingNeedles = () => {
  const bedRef = useRef<NeedleBedHandle>(null);
  const [step, setStep] = useState(0);

  return (
    <Box as="section" id="needles" maxW="maxw" mx="auto" px="pad" pb="sec">
      <SectionHead head={KNIT_NEEDLES_HEAD} />

      <Grid
        templateColumns={{ base: "minmax(0, 1fr)", lg: "minmax(0, 1.25fr) minmax(0, 0.75fr)" }}
        gap="clamp(32px, 4vw, 56px)"
        alignItems="start"
      >
        <NeedleBed ref={bedRef} onStepChange={setStep} />
        <StepList
          label={KNIT_NEEDLES.stepsLabel}
          steps={KNIT_NEEDLES.steps}
          active={step}
          onSelect={(index) => bedRef.current?.showStep(index)}
        />
      </Grid>
    </Box>
  );
};
